import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getCombosSvgFiltered,
  deleteComboSvg,
  updateComboSvg,
  insertComboSvg,
  getComboSvgById,
  updateCombosSvgProducto,
  getCombosSvgByProductoId,
  updateComboSvgProducto,
  getComboSvgProductoById,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
import history from '../../history'

export function* GET_COMBOSVG_FILTERED(action) {
  try {
    const combosSvgData = yield call(getCombosSvgFiltered, action.payload)
    if (combosSvgData.ok) {
      yield put({
        type: actions.COMBOSVG_FILTERED_LOAD_SUCCEEDED,
        payload: combosSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Combos SVG')
      put({
        type: actions.COMBOSVG_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.COMBOSVG_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_COMBOSVG(action) {
  try {
    const descuentoData = yield call(deleteComboSvg, action.payload)
    if (descuentoData.ok) {
      putMessage(messageType.SUCCESS, 'Combo SVG eliminada correctamente')
      yield put({
        type: actions.DELETE_COMBOSVG_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el Combo SVG')
      put({
        type: actions.DELETE_COMBOSVG_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el Combo SVG')
    yield all([
      put({
        type: actions.DELETE_COMBOSVG_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_COMBOSVG(action) {
  try {
    const comboSvg = yield call(insertComboSvg, action.payload)
    if (comboSvg.ok) {
      putMessage(messageType.SUCCESS, 'Combo SVG creada correctamente')
      history.push(`/combossvg/edit/${comboSvg.data.id}`)
      // yield put({
      //   type: actions.COMBOSVG_INSERT_SUCCEEDED,
      //   payload: comboSvg.data,
      // })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Combo SVG')
      yield put({
        type: actions.COMBOSVG_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Combo SVG')
    yield all([
      put({
        type: actions.COMBOSVG_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_COMBOSVG(action) {
  try {
    const comboSvg = yield call(updateComboSvg, action.payload)
    if (comboSvg.ok) {
      putMessage(messageType.SUCCESS, 'Combo SVG modificado correctamente')
      yield put({
        type: actions.COMBOSVG_UPDATE_SUCCEEDED,
        payload: comboSvg.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Combo SVG')
      yield put({
        type: actions.COMBOSVG_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Combo SVG')
    yield all([
      put({
        type: actions.COMBOSVG_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_COMBOSVG_BY_ID(action) {
  try {
    const combosSvgData = yield call(getComboSvgById, action.payload)
    if (combosSvgData.ok) {
      yield put({
        type: actions.COMBOSVG_BYID_LOAD_SUCCEEDED,
        payload: combosSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Combo SVG')
      put({
        type: actions.COMBOSVG_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.COMBOSVG_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_COMBOS_SVG_PRODUCTO(action) {
  try {
    const combosSvgProductoByProducto = yield call(updateCombosSvgProducto, action.payload)
    if (combosSvgProductoByProducto.ok) {
      putMessage(messageType.SUCCESS, 'Combos Svg modificados correctamente para este producto')
      yield put({
        type: actions.COMBOS_SVG_PRODUCTO_UPDATE_SUCCEEDED,
        payload: combosSvgProductoByProducto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Combos Svg para este producto')
      yield put({
        type: actions.COMBOS_SVG_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Combos Svg para este producto')
    yield all([
      put({
        type: actions.COMBOS_SVG_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_COMBOSVG_BY_PRODUCTO_ID(action) {
  try {
    const combosSvgProductoData = yield call(getCombosSvgByProductoId, action.payload)
    if (combosSvgProductoData.ok) {
      yield put({
        type: actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED,
        payload: combosSvgProductoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Combos Svg')
      put({
        type: actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Combos Svg')
    yield all([
      put({
        type: actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_COMBOSVG_PRODUCTO(action) {
  try {
    const combosSvgProductoByProducto = yield call(updateComboSvgProducto, action.payload)
    if (combosSvgProductoByProducto.ok) {
      putMessage(messageType.SUCCESS, 'Prediseños SVG modificados correctamente para este producto')
      yield put({
        type: actions.COMBOSVG_PRODUCTO_UPDATE_SUCCEEDED,
        payload: combosSvgProductoByProducto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Prediseños SVG para este producto')
      yield put({
        type: actions.COMBOSVG_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Prediseños SVG para este producto')
    yield all([
      put({
        type: actions.COMBOSVG_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_COMBOSVG_PRODUCTO_BY_ID(action) {
  try {
    const comboSvgProductoPredSvgData = yield call(getComboSvgProductoById, action.payload)
    if (comboSvgProductoPredSvgData.ok) {
      yield put({
        type: actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_SUCCEEDED,
        payload: comboSvgProductoPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Prediseños SVG')
      put({
        type: actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Prediseños SVG')
    yield all([
      put({
        type: actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.COMBOSVG_FILTERED_LOAD_REQUESTED, GET_COMBOSVG_FILTERED),
    takeEvery(actions.DELETE_COMBOSVG_REQUESTED, DELETE_COMBOSVG),
    takeEvery(actions.COMBOSVG_INSERT_REQUESTED, INSERT_COMBOSVG),
    takeEvery(actions.COMBOSVG_UPDATE_REQUESTED, UPDATE_COMBOSVG),
    takeEvery(actions.COMBOSVG_BYID_LOAD_REQUESTED, GET_COMBOSVG_BY_ID),
    takeEvery(actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_REQUESTED, GET_COMBOSVG_BY_PRODUCTO_ID),
    takeEvery(
      actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_REQUESTED,
      GET_COMBOSVG_PRODUCTO_BY_ID,
    ),
    takeEvery(actions.COMBOS_SVG_PRODUCTO_UPDATE_REQUESTED, UPDATE_COMBOS_SVG_PRODUCTO),
    takeEvery(actions.COMBOSVG_PRODUCTO_UPDATE_REQUESTED, UPDATE_COMBOSVG_PRODUCTO),
  ])
}
